




















































































import {Component} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import ReportsFilter from "@/components/Settings/Reports/ReportsFilter.vue";
import {ReportItem} from "@/store/settings/reports/types";
import {ScrollButton} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import { dateFilter } from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { ActionLog } from "@/store/auth/types";

@Component({
  components:{ReportsFilter, ScrollButton},
  filters: { dateFilter },
  methods: {colorClassByStatus}
})
export default class Reports extends BaseItemsPage<ReportItem> {
  @Getter("reports") reportsResponse: any;
  @Action("downloadReport") actionDownloadReport: any;
  @Action("actionLog") actionLog: any;
  @Action("deleteReport") deleteReport: any;

  is_show_filter = false;
  currentSort= "create_date";
  currentSortOrder= "desc";
  tableFields = [
    'create_date',
    'finish_date',
    'name',
    'status',
  ];
  private logObject: ActionLog = {}

  getData(): ReportItem[] {
    return this.reportsResponse;
  }

  async downloadReport(item: ReportItem) {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Report downloading",
        action_status: 'success',
        object_type: "Report",
        object_name: item.name,
      }
      await this.actionDownloadReport(item.id)
      await this.actionLog(this.logObject)
    } catch(error) {
      await this.actionLog({...this.logObject, action_status: 'failed'})
      notifyError(error)
    }
  }

  async onDeleteAction(report_id: number){
    const { filter } = this.$refs.filter as any;
    this.deleteReport({report_id, filter});
  }
}
